import type { ManagerAuthorization } from '@common/enums/managerAuthorization';

export const checkListForOneAuthorization = (
    authorizationsToBeChecked: ManagerAuthorization | ManagerAuthorization[],
    userAuthorizationsList: ManagerAuthorization[]
): boolean => {
    if (!Array.isArray(authorizationsToBeChecked)) {
        authorizationsToBeChecked = [authorizationsToBeChecked];
    }

    if (authorizationsToBeChecked.length === 0) {
        return true;
    }

    return authorizationsToBeChecked.some((authorizationToBeChecked: ManagerAuthorization) =>
        userAuthorizationsList.includes(authorizationToBeChecked)
    );
};

export const checkListForAllAuthorizations = (
    authorizationsToBeChecked: ManagerAuthorization[],
    userAuthorizationsList: ManagerAuthorization[]
): boolean => {
    if (authorizationsToBeChecked.length === 0) {
        return true;
    }

    return authorizationsToBeChecked.every((authorizationToBeChecked: ManagerAuthorization) =>
        userAuthorizationsList.includes(authorizationToBeChecked)
    );
};
